module.exports = __webpack_public_path__ + "static/media/2_en.aa191a1c.png";